import { useEffect, useState } from 'react'
import { parseApiDate } from '~/helpers/date'

export const useRemainingTimeDiscount = (expirationDate: string) => {
  const [timeRemaining, setTimeRemaining] = useState<string>('')

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const now = new Date().getTime()
      const expiry = parseApiDate(expirationDate)
      const diffMs = expiry - now

      if (diffMs <= 0) {
        setTimeRemaining('Expired')
        return
      }

      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24))
      const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))

      setTimeRemaining(`${days}d:${hours}h:${minutes}m`)
    }

    calculateTimeRemaining()
    const interval = setInterval(calculateTimeRemaining, 60000) // Update every minute

    return () => clearInterval(interval)
  }, [expirationDate])
  return { timeRemaining }
}
